import PayrollView from "../PayrollView.vue";
import PayrollList from "../Pages/PayrollList.vue";
import PayrollBatchUpload from '../Pages/PayrollBatchUpload.vue';
import PayrollDetails from "../Pages/PayrollDetails.vue";
import PayrollBatchList from "../Pages/PayrollBatchList.vue";
import PaymentMadeList from "../Pages/PaymentMadeList.vue";
import PaymentMadeUpload from "../Pages/PaymentMadeUpload.vue";
import PayrollMovementList    from "../Pages/PayrollMovementList.vue";
import PayrollMovementCreate  from "../Pages/PayrollMovementCreate.vue";
import PayrollMovementBulk    from "../Pages/PayrollMovementBulk.vue";
import PayrollMovementSummary from "../Pages/PayrollMovementSummary.vue";
import PayrollMovementGroupDetail from "../Pages/PayrollMovementGroupDetail.vue";
import PayrollEnginePage from "../Pages/PayrollEnginePage.vue";

const routes = [
  {
    path: '/planillas',
    component: PayrollView,
    children: [
      {
        path: '',
        name: 'payroll-list',
        component: PayrollList,
      },
      {
        path: ':id/detalles',
        name: 'payroll-details',
        component: PayrollDetails,
      },
      {
        path: 'externas',
        name: 'payroll-base-batch',
        component: PayrollBatchList
      },
      {
        path: 'externas/carga',
        name: 'payroll-base-batch-upload',
        component: PayrollBatchUpload
      },
      {
        path: 'abonos',
        name: 'payroll-status-made-batch-list',
        component: PaymentMadeList
      },
      {
        path: 'abonos/carga',
        name: 'payroll-status-made-batch-upload',
        component: PaymentMadeUpload
      },
      {
        path: 'movimientos',
        name: 'payroll-movement-list',
        component: PayrollMovementList,
      },
      {
        path: 'movimientos/crear',
        name: 'payroll-movement-create',
        component: PayrollMovementCreate,
      },
      {
        path: 'movimientos/:id/editar',
        name: 'payroll-movement-edit',
        component: PayrollMovementCreate,
      },
      {
        path: 'movimientos/masivo',
        name: 'payroll-movement-bulk',
        component: PayrollMovementBulk,
      },
      {
        path: 'movimientos/resumen',
        name: 'payroll-movement-summary',
        component: PayrollMovementSummary,
      },
      {
        path: 'movimientos/grupo/:groupId',
        name: 'movement-group-detail',
        component: PayrollMovementGroupDetail,
      },
      {
        path: 'motor',
        name: 'payroll-engine',
        component: PayrollEnginePage,
      },
    ]
  }
]

export default routes
